import React, {Fragment, Component} from 'react';
import classnames from 'classnames';
import {ItemContainer} from './style';
import {subString} from "../../../utils/tool";

class FilterItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.curSortIndex = 8;
  }

  componentDidMount() {
  }

  renderCurrentStatus = () => {
    const {defaultParam, changeParam, defaultIndex} = this.props;
    // 排序
    if (defaultIndex === 0) {
      // 特殊展示
      const {index, name, sort} = changeParam;
      if (name) {
        // 点击筛选项
        if (index === 8) {
          this.curSortIndex = 8;
          // 默认排序 展示默认样式
          return name;
        }
        if (index !== 8) {
          this.curSortIndex = index;
          return (<Fragment>
            <div className={'selected_filter_indicator'}>{name}</div>
            {
              sort !== -1 && <i className={classnames(['filter_sort_indicator', {
                'filter_sort_top': sort,
                'filter_sort_down': sort === 0,
              }])}></i>
            }
          </Fragment>);
        }

      } else {
        return subString(defaultParam, 4)
      }
    }

    if (defaultIndex !== 0) {
      // 配排序 正常展示
      return <Fragment>{!!changeParam ? subString(changeParam, 4) : subString(defaultParam, 4)}</Fragment>
    }
  }

  render() {
    const {currIndex, defaultParam, defaultIndex, clickHandle} = this.props;
    return (
      <ItemContainer onClick={() => {
        clickHandle({name: defaultParam, index: defaultIndex,})
      }}>
        <div className={classnames(["filter-content", {'actived': currIndex === defaultIndex}])}>
          {this.renderCurrentStatus()}
        </div>
        {
          defaultIndex === 0 && this.curSortIndex === 8 && <i className={'filter_sort_default'}></i>
        }
        {defaultIndex !== 0 &&
        <i className={classnames(["filter-indicator", {'actived': currIndex === defaultIndex}])}></i>}
      </ItemContainer>
    );
  }
}

export default FilterItem;
